// extracted by mini-css-extract-plugin
export default {"Label":"LNjBR7Keq5uQDQiRnS0m","Icon":"A4bMp1q1TxgMtaHIrsSI","Monogram":"fSJj8SIXa2kwz0YX3qkK"};